import request from '../utils/request'

export function backlogCustomerBacklogApi (params) {
  return request({
    url: 'api/backlog/customerBacklog',
    method: 'get',
    params
  })
}

export function waiveCustomerApi (data) {
  return request({
    url: 'api/customer/waiveCustomer',
    method: 'post',
    data
  })
}

export function auditGiveUpCustomerAuditApi (data) {
  return request({
    url: 'api/audit/giveUpCustomerAudit',
    method: 'post',
    data
  })
}

export function arsProjectAppQueryListApi (params = {}) {
  return request({
    url: 'api/arsProject/appQueryList',
    method: 'get',
    params
  })
}
